export const authUsersInitialState = {
	entities: {},
	totalToDisplay: 0,
	skip: 0,
};

export const authUserInitialState = {
	_id: undefined,
	name: '',
	subdomain: '',
	region: '',
	active: '',
	crm_type: '',
};



// WEBPACK FOOTER //
// ./src/redux/authUsers/authUser.initialState.js